export const cardTransformer = (response) => {
  const { table = [], headers } = response?.data || {};
  const result = {};

  headers?.forEach((header) => {
    result[header] = {
      source: null,
      compare: null,
    };
  });

  // Process each row based on the value at index 0 (ds)
  table?.forEach((row) => {
    const dsValue = row[0];

    if (dsValue === '2') {
      // This is source data
      headers?.forEach((header, idx) => {
        result[header].source = row[idx];
      });
    } else if (dsValue === '3') {
      // This is compare data
      headers?.forEach((header, idx) => {
        result[header].compare = row[idx];
      });
    }
  });

  return result;
};

// const getName = (input, key) => {
//   if (!input) return '-';
//   if (typeof input !== 'object') return input;
//   return input?.name ?? input?.title ?? input?.reason ?? input?.label;
// };

// export const cardTransformer = (response, payload) => {
//   const {
//     table = [],
//     headers,
//     lookups: { dt, g1, g2 } = {},
//   } = response?.data || {};

//   const { group: { group_by_1, group_by_2 } = {} } = payload || {};

//   return headers?.reduce((acc, header, idx) => {
//     if (header === 'g1' && typeof table[0][idx] === 'number') {
//       acc[header] = {
//         source: g1[table[0][idx]],
//         compare: g1[table[1]?.[idx]] || 0,
//         sourceName: getName(g1[table[0][idx]], group_by_1?.id),
//         compareName: getName(g1[table[1]?.[idx]], group_by_1?.id),
//       };
//       return acc;
//     }

//     if (header === 'g2' && typeof table[0][idx] === 'number') {
//       acc[header] = {
//         source: g2[table[0][idx]],
//         compare: g2[table[1]?.[idx]] || 0,
//         sourceName: getName(g2[table[0][idx]], group_by_2?.id),
//         compareName: getName(g2[table[1]?.[idx]], group_by_2?.id),
//       };
//       return acc;
//     }

//     acc[header] = {
//       source: table[0][idx],
//       compare: table[1]?.[idx] || 0,
//     };
//     return acc;
//   }, {});
// };
